<!-- ══════════════════════════════════════════════════════════════════════
     Vendor Register — split-panel visual rebuild (matches vendor-signin).
     3-step flow (identifier → OTP → details), all component TS logic
     preserved — only the shell + classes are new. Palette + typography
     from C:/Users/Dr/Downloads/vendor-login-preview.html.
     ══════════════════════════════════════════════════════════════════════ -->
<div class="vsi-layout">

  <!-- ═════ LEFT: maroon brand panel ═════ -->
  <div class="vsi-brand-panel">
    <div class="vsi-anim vsi-d3">
      <h1 class="vsi-headline">
        A new model for<br/>
        <em>creative execution.</em>
      </h1>
      <p class="vsi-lede">
        Structured by AI, delivered with human expertise — built on a century of
        Mahatta's production legacy. We solve the beginning, where most projects
        fail before execution begins.
      </p>
    </div>

    <div class="vsi-spacer-40"></div>

    <div class="vsi-anim vsi-d4">
      <p class="vsi-framework-label">THE FOUR-PART PLATFORM</p>
      <div class="vsi-stage-grid">
        <div class="vsi-stage-card">
          <div class="vsi-stage-num">01</div>
          <div class="vsi-stage-name">Scope</div>
          <div class="vsi-stage-desc">AI-assisted project planning</div>
        </div>
        <div class="vsi-stage-card">
          <div class="vsi-stage-num">02</div>
          <div class="vsi-stage-name">Source</div>
          <div class="vsi-stage-desc">AI-assisted partner matching</div>
        </div>
        <div class="vsi-stage-card">
          <div class="vsi-stage-num">03</div>
          <div class="vsi-stage-name">Bid</div>
          <div class="vsi-stage-desc">Structured bid comparison</div>
        </div>
        <div class="vsi-stage-card">
          <div class="vsi-stage-num">04</div>
          <div class="vsi-stage-name">Execute</div>
          <div class="vsi-stage-desc">End-to-end project delivery</div>
        </div>
      </div>
    </div>

    <div class="vsi-anim vsi-d5 vsi-footer-row">
      <div>
        <div class="vsi-stat-label">BY MAHATTA</div>
        <div class="vsi-footer-line">
          <span class="vsi-footer-line-animated">Serving Creativity since 1915</span>
        </div>
      </div>
    </div>
  </div>

  <!-- ═════ RIGHT: cream auth panel ═════ -->
  <div class="vsi-action-panel">
    <div class="vsi-panel-body">

      <!-- Logo -->
      <div class="vsi-anim vsi-d2 vsi-center vsi-logo-block">
        <img src="assets/images/logos/studioip logo black.png"
             alt="StudioIP"
             class="vsi-logo-img" />
        <div class="vsi-logo-tagline">India's 1<sup>st</sup> AI-assisted creative execution platform</div>
      </div>

      <!-- Step progress -->
      <div class="vsi-step-progress" *ngIf="!isGoogleSignup">
        <div class="vsi-step-dot"
             [class.on]="currentStep === 'identifier'"
             [class.done]="currentStep === 'otp' || currentStep === 'details'"></div>
        <div class="vsi-step-line"
             [class.done]="currentStep === 'otp' || currentStep === 'details'"></div>
        <div class="vsi-step-dot"
             [class.on]="currentStep === 'otp'"
             [class.done]="currentStep === 'details'"></div>
        <div class="vsi-step-line" [class.done]="currentStep === 'details'"></div>
        <div class="vsi-step-dot" [class.on]="currentStep === 'details'"></div>
      </div>

      <!-- ─── STEP 1: identifier ─── -->
      <ng-container *ngIf="currentStep === 'identifier'">

        <p class="vsi-eyebrow">NEW VENDOR</p>
        <h2 class="vsi-panel-h2">Register with <em>StudioIP</em></h2>

        <!-- Google Sign-Up (SDK renders native button) -->
        <div class="vsi-google-wrap" id="google-signin-btn"></div>

        <div class="vsi-divider"><hr/><span>OR REGISTER WITH</span><hr/></div>

        <p class="vsi-small-note vsi-note-lead">
          Enter your email or phone number to get started.
        </p>

        <input
          type="text"
          class="vsi-auth-input"
          [(ngModel)]="identifier"
          [placeholder]="identifierPlaceholder"
          (keydown.enter)="sendOtp()"
          [disabled]="isLoading"
          autocomplete="username"
          autofocus />

        <div class="vsi-field-error" *ngIf="identifierError">
          <i-tabler name="alert-circle" style="width:14px;height:14px;"></i-tabler>
          {{ identifierError }}
        </div>

        <button type="button"
                class="vsi-primary-btn"
                [disabled]="!isValidIdentifier || isLoading"
                (click)="sendOtp()">
          <span *ngIf="!isLoading">Continue</span>
          <mat-spinner *ngIf="isLoading" diameter="18" class="vsi-spinner-inline"></mat-spinner>
        </button>

        <div class="vsi-security-note">
          <i-tabler name="shield-check" style="width:12px;height:12px;"></i-tabler>
          <span>We'll send a one-time code to verify your identity.</span>
        </div>

        <p class="vsi-small-note">
          Already have an account?
          <a routerLink="/vendors/login"><span>Sign in</span></a>
        </p>
      </ng-container>

      <!-- ─── STEP 2: OTP verify ─── -->
      <ng-container *ngIf="currentStep === 'otp'">
        <div class="vsi-back-link vsi-back-link-offset" (click)="goBackToIdentifier()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
               fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
            <path fill-rule="evenodd"
              d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
          </svg>
          Change {{ isEmail ? 'email' : 'number' }}
        </div>

        <p class="vsi-eyebrow">VERIFY IT'S YOU</p>
        <h2 class="vsi-panel-h2">Enter your <em>one-time code</em></h2>

        <p class="vsi-small-note vsi-note-lead">
          We sent a 6-digit code to <strong>{{ maskedIdentifier }}</strong>
          via {{ otpChannel === 'email' ? 'email' : 'SMS' }}.
        </p>

        <input
          type="text"
          inputmode="numeric"
          class="vsi-auth-input vsi-otp-input"
          [(ngModel)]="otpCode"
          placeholder="——————"
          maxlength="6"
          (input)="formatOtpInput($event)"
          (keydown.enter)="verifyOtp()"
          [disabled]="isLoading"
          autocomplete="one-time-code"
          autofocus />

        <div class="vsi-field-error" *ngIf="otpError">
          <i-tabler name="alert-circle" style="width:14px;height:14px;"></i-tabler>
          {{ otpError }}
        </div>

        <button type="button"
                class="vsi-primary-btn"
                [disabled]="otpCode.length !== 6 || isLoading"
                (click)="verifyOtp()">
          <span *ngIf="!isLoading">Verify &amp; continue</span>
          <mat-spinner *ngIf="isLoading" diameter="18" class="vsi-spinner-inline"></mat-spinner>
        </button>

        <div class="vsi-resend-row">
          <button type="button"
                  class="vsi-resend-btn"
                  [disabled]="otpTimer > 0"
                  (click)="resendOtp()">
            <span *ngIf="otpTimer > 0">Resend in {{ otpTimer }}s</span>
            <span *ngIf="otpTimer === 0">Resend OTP</span>
          </button>
        </div>

        <p class="vsi-small-note">OTP expires in 10 minutes.</p>
      </ng-container>

      <!-- ─── STEP 3: complete profile ─── -->
      <ng-container *ngIf="currentStep === 'details'">
        <div class="vsi-back-link vsi-back-link-offset" *ngIf="!isGoogleSignup" (click)="goBackToOtp()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
               fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
            <path fill-rule="evenodd"
              d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
          </svg>
          Back
        </div>

        <p class="vsi-eyebrow">FINAL STEP</p>
        <h2 class="vsi-panel-h2">Complete your <em>profile</em></h2>

        <div class="vsi-verified-badge">
          <i-tabler [name]="isEmail || isGoogleSignup ? 'mail-check' : 'device-mobile-check'" style="width:14px;height:14px;"></i-tabler>
          <span class="vsi-verified-identifier">{{ identifier }}</span>
          <span class="vsi-verified-tag">Verified</span>
        </div>

        <!-- Account type toggle -->
        <label class="vsi-field-label">I'm registering as</label>
        <div class="vsi-method-toggle">
          <button type="button"
                  class="vsi-method-tab"
                  [class.on]="accountType === 'individual'"
                  (click)="setAccountType('individual')">
            Individual / Freelancer
          </button>
          <button type="button"
                  class="vsi-method-tab"
                  [class.on]="accountType === 'agency'"
                  (click)="setAccountType('agency')">
            Agency / Production House
          </button>
        </div>

        <!-- Full name — only for individual signup. Agencies use their
             agency name as the account identity, so we skip this field
             entirely and don't send it in the payload. -->
        <ng-container *ngIf="accountType === 'individual'">
          <label class="vsi-field-label">Full name <span class="vsi-req">*</span></label>
          <input
            type="text"
            class="vsi-auth-input"
            [(ngModel)]="fullName"
            placeholder="Enter your full name"
            [disabled]="isLoading" />
        </ng-container>

        <!-- Agency name (conditional) -->
        <ng-container *ngIf="accountType === 'agency'">
          <label class="vsi-field-label">Agency name <span class="vsi-req">*</span></label>
          <input
            type="text"
            class="vsi-auth-input"
            [(ngModel)]="agencyName"
            placeholder="Enter your agency name"
            [disabled]="isLoading" />
        </ng-container>

        <!-- Secondary contact: phone -->
        <ng-container *ngIf="needsPhone">
          <label class="vsi-field-label">Phone number <span class="vsi-opt">Optional</span></label>
          <input
            type="text"
            class="vsi-auth-input"
            [class.has-error]="phoneExistsError"
            [(ngModel)]="secondaryContact"
            placeholder="Add your phone for easier access"
            [disabled]="isLoading"
            maxlength="10"
            (blur)="checkPhoneExists()" />
          <div class="vsi-field-error" *ngIf="secondaryContactError">
            <i-tabler name="alert-circle" style="width:14px;height:14px;"></i-tabler>
            {{ secondaryContactError }}
            <a *ngIf="phoneExistsError" class="vsi-inline-action" (click)="redirectToPhoneLogin()">Log in instead</a>
          </div>
        </ng-container>

        <!-- Secondary contact: email -->
        <ng-container *ngIf="needsEmail">
          <label class="vsi-field-label">Email address <span class="vsi-opt">Optional</span></label>
          <input
            type="email"
            class="vsi-auth-input"
            [(ngModel)]="secondaryContact"
            placeholder="Add your email for notifications"
            [disabled]="isLoading" />
        </ng-container>

        <!-- Terms of Use + Privacy Policy consent -->
        <label class="vsi-tc-row">
          <input type="checkbox" [(ngModel)]="agreedToTerms" class="vsi-tc-checkbox" />
          <span class="vsi-tc-text">
            I agree to the
            <a class="vsi-tc-link" href="#" (click)="legalModal = 'terms'; $event.preventDefault()">Terms of Use</a>
            and the
            <a class="vsi-tc-link" href="#" (click)="legalModal = 'privacy'; $event.preventDefault()">Privacy Policy</a>
          </span>
        </label>

        <button type="button"
                class="vsi-primary-btn"
                [disabled]="isLoading"
                (click)="completeSignup()">
          <span *ngIf="!isLoading">Create account</span>
          <mat-spinner *ngIf="isLoading" diameter="18" class="vsi-spinner-inline"></mat-spinner>
        </button>

        <p class="vsi-small-note">
          Already have an account?
          <a routerLink="/vendors/login"><span>Sign in</span></a>
        </p>
      </ng-container>

    </div>
  </div>
</div>

<!-- Help Desk FAB -->
<button type="button" class="vsi-help-fab" (click)="showHelpModal = true" matTooltip="Help & Support">
  <i-tabler name="headset" style="width:22px;height:22px;"></i-tabler>
</button>

<!-- Help Desk Modal -->
<div class="vsi-help-overlay" *ngIf="showHelpModal" (click)="showHelpModal = false">
  <div class="vsi-help-modal" (click)="$event.stopPropagation()">
    <div class="vsi-help-modal-header">
      <h3 class="vsi-help-modal-title">Help &amp; Support Desk</h3>
      <button type="button" class="vsi-help-modal-close" (click)="showHelpModal = false">
        <i-tabler name="x" style="width:18px;height:18px;"></i-tabler>
      </button>
    </div>
    <div class="vsi-help-modal-body">
      <p class="vsi-help-subtitle">Need help? We're here for you.</p>
      <p class="vsi-help-desc">
        If you have any questions during registration or login, our team is ready
        to assist you.
      </p>
      <div class="vsi-help-contact-card">
        <div class="vsi-help-contact-item">
          <div class="vsi-help-icon-wrap">
            <i-tabler name="phone" style="width:20px;height:20px;"></i-tabler>
          </div>
          <div>
            <a href="tel:+918448997281" class="vsi-help-contact-value">+91-8448997281</a>
            <div class="vsi-help-contact-label">Call us anytime for a quick solution</div>
          </div>
        </div>
        <div class="vsi-help-contact-item">
          <div class="vsi-help-icon-wrap">
            <i-tabler name="mail" style="width:20px;height:20px;"></i-tabler>
          </div>
          <div>
            <a href="mailto:submission&#64;mahatta.com" class="vsi-help-contact-value">submission&#64;mahatta.com</a>
            <div class="vsi-help-contact-label">Send us a mail to resolve your issue</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Terms of Use / Privacy Policy reader (shared with client signup) -->
<app-legal-modal
  *ngIf="legalModal"
  [doc]="legalModal"
  (closed)="legalModal = null"
  (agreed)="agreedToTerms = true; legalModal = null">
</app-legal-modal>